import auctionIndex from "@/views/auction/index.vue"
import auctionDetail from "@/views/auction/detail.vue"
import auctionLogin from "@/views/auction/login.vue"
import auctionMy from "@/views/auction/my.vue"
import projectDetails from "@/views/auction/projectDetails.vue"

const auction = [{
    path: 'auction',
    name: 'auction',
    component: auctionIndex,
    meta: { activeMenuIndex: 2 },
}, {
    path: 'auctionDetail',
    name: 'auctionDetail',
    component: auctionDetail,
    meta: { activeMenuIndex: 2 },
},{
    path: 'auctionLogin',
    name: 'auctionLogin',
    component: auctionLogin,
    meta: { activeMenuIndex: 2 },
},{
    path: 'auctionMy',
    name: 'auctionMy',
    component: auctionMy,
    meta: { activeMenuIndex: 2 },
},
{
    path: 'projectDetails',
    name: 'projectDetails',
    component: projectDetails,
    meta: { activeMenuIndex: 2 },
}
 ]
export default auction


// WEBPACK FOOTER //
// ./src/router/auction/index.js